import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["tab", "panel"]

    connect() {
        // Only set up if we have tabs
        if (this.tabTargets.length > 0) {
            this.show(this.tabTargets[0].dataset.tabId)
        }
    }

    select(event) {
        this.show(event.currentTarget.dataset.tabId)
    }

    show(tabId) {
        this.tabTargets.forEach(tab => {
            const isActive = tab.dataset.tabId === tabId

            // Common classes to both states
            if (isActive) {
                tab.classList.add("border-[#D7B781]", "text-[#D7B781]")
                tab.classList.remove("border-transparent", "text-gray-400", "hover:text-white")
            } else {
                tab.classList.add("border-transparent", "text-gray-400", "hover:text-white")
                tab.classList.remove("border-[#D7B781]", "text-[#D7B781]")
            }
        })

        this.panelTargets.forEach(panel => {
            if (panel.dataset.tabId === tabId) {
                panel.classList.remove("hidden")
            } else {
                panel.classList.add("hidden")
            }
        })
    }
}
